import React, { useMemo } from "react";

const FOOD_EMOJIS = [
	"🍔", "🍕", "🍣", "🍜", "🍰", "🍩", "🍪", "🥗", "🥪", "🌮", "🌯", "🍤", "🥟", "🥞", "🧁", "🍇", "🍉", "🍓", "🍒", "🍱"
];

export function Spinner({ size = 40, style }) {
	const emoji = useMemo(() => FOOD_EMOJIS[Math.floor(Math.random() * FOOD_EMOJIS.length)], []);
	const fontSize = typeof size === "number" ? `${size}px` : size;

	return (
		<span
			className="rb-spinner"
			style={{ fontSize: fontSize, lineHeight: 1, display: "inline-block", ...style }}
			role="progressbar"
			aria-label="Loading"
		>
			<span aria-hidden="true" role="img" aria-label="food-spinner">{emoji}</span>
		</span>
	);
}
